import { injectable } from 'inversify';
import { IPadOptions, IPadOptionsService } from './pad-options.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class PadOptionsMock implements IPadOptionsService {
    configObs = (): Observable<IPadOptions> => NEVER;
}
